<template>
    <clients-section title="They Chose Us|Ils nous ont choisis">
        <client-card src="img/clients-color/real-estate/cominar.png">
            Cominar
        </client-card>
        <client-card src="img/clients-color/retail/loreal_canada.png">
            L'Oréal Canada
        </client-card>
        <client-card src="img/clients-color/municipalities/montreal.png">
            Ville de Montréal
        </client-card>
        <client-card src="img/clients-color/municipalities/ville-bromont.png" bg>
            Ville de Bromont
        </client-card>
        <client-card src="img/clients-color/municipalities/cote_st_luc.png">
            Côte-St-Luc
        </client-card>
        <client-card src="img/clients-color/manufacturer/life-science-nutritional.png">
            Life Science Nutritional
        </client-card>
        <client-card src="img/clients-color/municipalities/westmount.png">
            Westmount
        </client-card>
        <client-card src="img/clients-color/municipalities/bois_des_filion.png">
            Ville de Bois des Filion
        </client-card>
        <client-card src="img/clients-color/municipalities/gatineau.png">
            Ville de Gatineau
        </client-card>
        <client-card src="img/clients-color/entertainment/clip-n-climb.png">
            Clip and Climb
        </client-card>
        <client-card src="img/clients-color/retail/nedco.png">
            Nedco
        </client-card>
    </clients-section>
</template>

<script>
import ClientCard from "@/components/client-card.vue";
import ClientsSection from "@/components/clients-section.vue";

export default {
    name: `signage-corporate-office-client-cards`,
    components: {ClientCard, ClientsSection},
    data() {
        return {
            altPrefix: this.tr(`Corporate Office Digital Signage Client|Client Affichage numérique professionnel`)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
